<template>
  <div :class="`zhandianbox ${type ? 'zhandianbox1' : ''}`">
    <div class="zhandian">
      <div v-for="(item, index) in data1" class="p10" :key="index">
        <a :href="item.url">
          <img :src="item.avatar" alt="" />
          <p>{{ item.name }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from "vue";
import { data1 } from "../utils/data";

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  type: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "站点推荐⬇⬇⬇⬇",
  },
});

const { list } = toRefs(props);
</script>

<style lang="scss" scoped>
.zhandianbox {
  border: 2px solid #008000;
}
.zhandian {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 12px;
  text-align: center;
  div {
    width: 100%;
    border-radius: 35px;
    a {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
}
.zhandianbox1 {
  .zhandian {
    gap: 1px;
    display: grid;
    padding: 0 !important;
    div {
      width: 100%;
      border-radius: 0px;
      a {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>